<body>
  <div *ngIf="!isBroker" class="mat-elevation-z8 ccorbit-mat-table col-settings-wrapper" [cdkContextMenuTriggerFor]="context_menu">

    <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
         [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
        <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
      </div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <div class="col-panel-option" *ngFor="let column of tableColumns">
          <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">
            {{column.name}}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div *ngIf="modelo && modeloCalculadoEn" class="modelo-calculado">
      Modelo calculado a las {{ modeloCalculadoEn }} (hora local). Las operaciones posteriores aparecen al recalcular.
    </div>
    <cdk-virtual-scroll-viewport #viewportCartera id="viewportGestion" item [appendOnly]="false" [tvsItemSize]="24"
      [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle" *ngIf="modelo">
      <table cdk-table [dataSource]="posdata" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="tablecol.id === 'fechaOperacion' ? orderByField('posdata', 'fechaOperacion') : 
                                                                                (tablecol.id === 'nombreCompania' ? orderByField('posdata', 'nombreCompania') : null)">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                                              'numero-positivo': item[tablecol.id] > 0,
                                                              'numero-negativo': item[tablecol.id] < 0
                                                              }">
              <ng-container *ngIf="tablecol.isString &&  tablecol.id !== 'hora' && tablecol.id !== 'horaCotizacion'">
                {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'nombreCompania'">
                  {{item['secType'] === 'CFD' ? ' CFD' : ''}}
                </ng-container>
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'cotizacion'|| tablecol.id === 'stoploss') ? '1.5-5' : '1.2-2')}}
              </ng-container>
              <ng-container *ngIf="tablecol.id === 'hora'">
                {{ isPlanificador ? '—' : formatHoraCotizacion(item['hora']) }}
              </ng-container>
              <ng-container *ngIf="tablecol.id === 'horaCotizacion'">
                {{ formatHoraCotizacion(item['horaCotizacion'])}}
              </ng-container>
  

            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

    <!-- COMIENZA TABLA CARTERA DIVERSIFICADOR -->
    <cdk-virtual-scroll-viewport #viewportCartera id="viewportDiv" item [appendOnly]="false" [tvsItemSize]="24"
      [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle" *ngIf="isPlanificador">
      <table cdk-table [dataSource]="divPosdata" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header" (click)="tablecol.id === 'fechaOperacion' ? orderByField('divPosdata', 'fechaOperacion') : 
                                                                                (tablecol.id === 'nombreCompania' ? orderByField('divPosdata', 'nombreCompania') : null)">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                                              'numero-positivo': item[tablecol.id] > 0,
                                                              'numero-negativo': item[tablecol.id] < 0
                                                              }">
              <ng-container *ngIf="tablecol.isString &&  tablecol.id !== 'hora' && tablecol.id !== 'horaCotizacion'">
                {{item[tablecol.id]}}
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'cotizacion' || tablecol.id === 'stoploss') ? '1.5-5' : '1.2-2')}}
              </ng-container>
              <ng-container *ngIf="tablecol.id === 'hora'">
                {{ formatHoraCotizacion(item['hora'])}}
              </ng-container>
              <ng-container *ngIf="tablecol.id === 'horaCotizacion'">
                {{ formatHoraCotizacion(item['horaCotizacion'])}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

    <!-- -----------------------GESTOR ------------- -->
    <cdk-virtual-scroll-viewport #viewportCarteraGest id="viewportCarteraGest" item [appendOnly]="false"
      [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle" *ngIf="isGestion">
      <table cdk-table [dataSource]="gestPosdata" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header" (click)="tablecol.id === 'fechaOperacion' ? orderByField('gestor', 'fechaOperacion') : 
                                                                                (tablecol.id === 'nombreCompania' ? orderByField('gestor', 'nombreCompania') : null)">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                            'entrada': item[tablecol.id] === 'ENTRADA',
                                                            'numero-positivo': item[tablecol.id] > 0,
                                                            'numero-negativo': item[tablecol.id] < 0
                                                            }">
              <ng-container *ngIf="tablecol.isString &&  tablecol.id !== 'hora' && tablecol.id !== 'horaCotizacion'">
                {{item[tablecol.id]}} 
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'cotizacion') ? '1.5-5' : '1.2-2')}}
              </ng-container>
              <ng-container *ngIf="tablecol.id === 'hora'">
                {{ formatHoraCotizacion(item['hora'])}}
              </ng-container>
              <ng-container *ngIf="tablecol.id === 'horaCotizacion'">
                {{ formatHoraCotizacion(item['horaCotizacion'])}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
    
  </div>

  <!-- -----------------------BROKER: posiciones + operaciones (vista MetaTrader) ------------- -->
  <div *ngIf="isBroker" #split class="broker-split">
    <app-posiciones-broker [stkcfd]="stkcfd" [ordenes]="lo.ordenesOriginal" [alto]="altoPosiciones"
      (salidaRealizada)="listaOrdenes?.recargar()"></app-posiciones-broker>
    <div class="split-handle" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
      (mousedown)="iniciarResize($event, split)" (dblclick)="resetSplit()"></div>
    <app-operaciones-mt [mostrarCola]="true" [alto]="altoOrdenes"></app-operaciones-mt>
    <!-- Tabla vieja de órdenes: oculta, pero montada porque alimenta posiciones y listaOrdenesBroker -->
    <app-lista-ordenes #lo class="oculta" [mostrarCola]="true"
      (ordenesCargadas)="listaOrdenesBroker.emit($event)"></app-lista-ordenes>
  </div>
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="100"></mat-spinner>
  </div>
  <ng-template #context_menu let-data="data">
    <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
      <button class="example-menu-item" (click)="verModelo()" cdkMenuItem>
        <mat-icon class="menu-icon">open_in_new</mat-icon>
        <span>Ver Modelo</span>
      </button>
      <button class="example-menu-item" (click)="verGrafica()" cdkMenuItem>
        <mat-icon class="menu-icon">insert_chart</mat-icon>
        <span>Ver Gráfica</span>
      </button>
      <button class="example-menu-item" (click)="openDialog(false)" cdkMenuItem *ngIf="isGestion">
        <mat-icon class="menu-icon">exit_to_app</mat-icon>
        <span>Operaciones de Salida</span>
      </button>

    </div>
  </ng-template>
</body>